import { Popover, Tooltip } from 'antd'
import { useState } from 'react'

import { CalculationKeyboard } from '../../CalculationKeyboard'
import { FORMULAS } from '../../constants'

type Props = {
  onClick: (key: string) => void
}

export const FunctionOptions = ({ onClick }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const closePopover = () => setIsOpen(false)

  return (
    <Popover
      classNames={{ body: '!px-0' }}
      content={
        <div className="flex w-full flex-col items-center [&>button:last-child]:border-b-transparent">
          {FORMULAS.map(({ value, formula, key }) => (
            <button
              className="flex w-full flex-col items-start justify-start gap-0.5 rounded-sm border-b border-transparent border-b-gray-200 bg-transparent px-2.5 py-2.5 pl-3 pr-8 text-base text-gray-800 outline-none hover:!bg-gray-100 hover:bg-gray-100/80 focus:outline-none disabled:cursor-not-allowed [&:hover_.info]:block"
              onClick={() => {
                onClick(key)
                closePopover()
              }}
              type="button"
            >
              <span className="font-bold text-gray-800">{value}</span>
              <span className="text-xs font-medium text-gray-500">
                {formula}
              </span>
            </button>
          ))}
        </div>
      }
      getPopupContainer={() => document.body}
      onOpenChange={() => setIsOpen((old) => !old)}
      open={isOpen}
      placement="bottom"
      trigger="click"
    >
      <Tooltip mouseEnterDelay={0.7} title="Click to select a function">
        <CalculationKeyboard.Button className="col-span-2 text-sm">
          FUNCTIONS
        </CalculationKeyboard.Button>
      </Tooltip>
    </Popover>
  )
}
